import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/jdechildafe',
  component: () => import('@views/JdeChildAfe/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'jdechildafe.index',
      component: () => import('@/components/JdeChildAfe/JdeChildAfe')
    },
  ]
}
